import React, { useState } from "react";
import { connect } from "react-redux";
import ImageModal from "../../../../components/imageModal";
import * as types from "../../../../actions/actionTypes";

const GuestsDeniedModal = props => {
  const removeProjectIdFromSessionStorage = () => {
    if (props.shouldReload) {
      localStorage.removeItem("project_id");
      window.location.reload();
    }
    props.handleShow(false);
  };

  if (!props.status) {
    return null;
  } else {
    return (
      <ImageModal
        key={Math.random()}
        image={{
          src: "/images/access_denied_guest_users_illustration.svg",
          alt: "guests"
        }}
        icon="mapsa-users-setting"
        title="کاربران مهمان در پروژه"
        description="دسترسی شما به دلیل پایان اعتبار اشتراک حرفه‌ای از پروژه مسدود شده است."
        rightButtons={[]}
        leftButtons={[
          {
            type: "ghost",
            borderless: false,
            onClick: removeProjectIdFromSessionStorage,
            title: "متوجه شدم"
          },
          {
            type: "outline",
            borderless: true,
            onClick: () => {
              props.send(props.projectId);
              removeProjectIdFromSessionStorage();
            },
            title: "ارسال درخواست تمدید اعتبار"
          }
        ]}
      />
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {
    send: (id) => {
      dispatch({ type: types.WARN_OWNER_REQUEST, id });
    }
  };
};
export default connect(
  null,
  mapDispatchToProps
)(GuestsDeniedModal);
